const MainTitle = ({ title }: { title: string }) => {
  return (
    <div className=" my-4 px-[18px]">
      <h1 className="text-[32px] leading-9 font-bold text-black">{title}</h1>
    </div>
  );
};

export default MainTitle;
